import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { siteInfo, submitChannels } from "@/mocks/site";

export default function ChannelSection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100 border-y border-background-200" aria-labelledby="channel-title">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          id="channel-title"
          eyebrow="投稿通道"
          title="三条通道，选你觉得最安心的一条"
          desc="不管你习惯填表、私信还是发邮件，材料都会进入同一个核查队列。渠道不同，保障相同。"
        />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {submitChannels.map((channel) => (
            <article
              key={channel.title}
              className="flex flex-col rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 hover:border-primary-300 transition-colors"
            >
              <span className="w-12 h-12 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${channel.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{channel.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{channel.desc}</p>
              <Link
                to={channel.href}
                className="mt-5 inline-flex items-center gap-1.5 text-sm font-label text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                {channel.action}
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              </Link>
            </article>
          ))}
        </div>

        <div className="mt-6 rounded-lg bg-foreground-950 text-background-50 p-5 md:p-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-start gap-4">
            <span className="w-11 h-11 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center shrink-0">
              <i className="ri-mail-send-line text-xl" aria-hidden="true"></i>
            </span>
            <div>
              <h3 className="font-heading text-base font-bold">材料较多？直接发到编辑邮箱</h3>
              <p className="mt-1 text-sm text-background-200/85 font-label break-all">
                {siteInfo.email}
              </p>
            </div>
          </div>
          <a
            href={`mailto:${siteInfo.email}`}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-50 text-foreground-950 text-sm font-label font-medium whitespace-nowrap hover:bg-accent-100 transition-colors cursor-pointer"
          >
            <i className="ri-external-link-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            打开邮件客户端
          </a>
        </div>
      </div>
    </section>
  );
}